import React, { memo, useEffect, useRef } from 'react';
import { useBoolean } from 'react-use';
import { twMerge } from 'tailwind-merge';
import { Element } from '../base';

const DEPLAY = 50;

export function Loader({ text, className }: any) {
    const timer = useRef<NodeJS.Timeout>();
    const state = useRef<string>();
    const [isLoading, setLoading] = useBoolean(false);

    const load = () => {
        if (state.current === 'loading') {
            return;
        }
        state.current = 'loading';
        timer.current = setTimeout(() => {
            setLoading(true);
        }, DEPLAY);
    };

    useEffect(() => {
        load();

        return () => {
            clearTimeout(timer.current as NodeJS.Timeout);
        };
    }, []);

    if (!isLoading) {
        return null;
    }

    return (
        <Element className={'text-center'}>
            <Element
                className={twMerge(
                    'inline-block',
                    'fixed top-1/2 left-1/2',
                    'w-[40px] h-[40px]',
                    'ml-[-20px] mt-[-20px]',
                    'rounded-full',
                    'border-[5px] border-solid border-[#f3f3f3] border-t-[#555]',
                    'animate-spin',
                    className
                )}
            ></Element>
            <Element renderAs="span">{text}</Element>
        </Element>
    );
}

export default memo(Loader);
